import doenerCase from "scripts/doenerCase"
import React, { useState } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"

export const JobPostingCard = ({ job, in_article, no_image }) => {
  const {
    customer,
    has_attention_booster,
    location,
    path,
    strapi_id,
    teaser,
    title,
  } = job

  const [expanded, set_expanded] = useState(false)

  const toggle_expand_teaser = (e) => {
    e.preventDefault()
    set_expanded(!expanded)
  }

  return (
    <div
      className={`box${in_article ? " is-shadowless mb-0" : ""}${
        !!has_attention_booster ? " has-background-mitternachtsblau-5" : ""
      }`}
      style={{ width: "100%" }}
    >
      <div className="columns" style={{ width: "100%", minHeight: 150 }}>
        {no_image ? null : (
          <div className="column is-2 is-flex">
            <Link
              to={`/fachzeitschriften/jobs-in-der-bauwirtschaft/firmen/${doenerCase(
                customer.name
              )}`}
              className="m-auto"
            >
              {!!customer.logo ? (
                <GatsbyImage
                  {...{
                    className: "m-auto hoverzoom",
                    alt: title,
                    image:
                      customer.logo.localFile.childImageSharp.gatsbyImageData,
                  }}
                />
              ) : !!customer.image_path ? (
                <img
                  src={customer.image_path}
                  alt={customer.name}
                  className="hoverzoom"
                />
              ) : (
                <div
                  className={`m-auto has-background-mitternachtsblau${
                    !!has_attention_booster ? "" : "-10"
                  } is-flex`}
                  style={{ width: 66, height: 66, borderRadius: "50%" }}
                >
                  <p
                    className={`title is-3 has-text-${
                      !!has_attention_booster ? "white" : "mitternachtsblau"
                    } mx-auto mt-auto mb-3`}
                  >
                    {customer.name.slice(0, 2).toUpperCase()}
                  </p>
                </div>
              )}
            </Link>
          </div>
        )}
        <Link
          className="column is-flex is-flex-direction-column"
          to={
            path ||
            `/fachzeitschriften/jobs-in-der-bauwirtschaft/jobs/${doenerCase(
              title
            )}-${strapi_id}`
          }
        >
          <p className="title is-6 has-text-mitternachtsblau mb-2 mt-auto">
            {title}
          </p>
          <p className="has-text-evergabe">
            {location} | {customer.name}
          </p>
          <p className="mt-4 has-text-mitternachtsblau mb-auto">
            {teaser.length > 75 ? (
              <React.Fragment>
                {!expanded ? (
                  <React.Fragment>
                    {teaser.slice(0, 75)}...{" "}
                    <span
                      aria-label="see more!"
                      role="button"
                      tabIndex={-1}
                      onClick={toggle_expand_teaser}
                      onKeyDown={() => {}}
                      className="link is-semi-shy"
                    >
                      mehr
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {teaser}{" "}
                    <span
                      role="button"
                      aria-label="see less!"
                      tabIndex={-2}
                      onClick={toggle_expand_teaser}
                      onKeyDown={() => {}}
                      className="link is-semi-shy"
                    >
                      weniger
                    </span>
                  </React.Fragment>
                )}
              </React.Fragment>
            ) : (
              teaser
            )}
          </p>
        </Link>
      </div>
    </div>
  )
}
